import { ColDef } from "ag-grid-community";
import { TableCellButton } from "./table-cell-button.model";
import { TableRow } from "./table-row.model";
import { TableColumn } from "../netgen/TableColumn";

export class TableCellEvent {

    constructor (public value: any, public row: TableRow, public column: ColDef, public rowIndex: number, public columnIndex: number) {
    }

    isButton(buttonName: string, columnId?: string): boolean {
        return this.value instanceof TableCellButton && this.value .id == buttonName && (columnId == null || columnId == this.column.colId); 
    }

    getTableColumn(): TableColumn {
        return this.column.context.tableColumn as TableColumn;
    }

}
